import { env } from 'src/env.mjs';
import { Keys } from 'src/helpers/typeUtils';

export const PREFERENCE_LABELS = {
    marketing: 'Marketing offers and updates',
    surveys: 'Surveys and feedback',
    product: 'Product updates',
    newsletter: 'Newsletter',
    health: 'Your health journey',
} as const;

export const emailPreferencesStaging = {
    '869272890': PREFERENCE_LABELS.marketing,
    '869272794': PREFERENCE_LABELS.surveys,
    '869272953': PREFERENCE_LABELS.product,
    '869272585': PREFERENCE_LABELS.newsletter,
    '869272733': PREFERENCE_LABELS.health,
} as const;

export const emailPreferencesProduction = {
    '1201699': PREFERENCE_LABELS.marketing,
    '44212576': PREFERENCE_LABELS.surveys,
    '4801616': PREFERENCE_LABELS.product,
    '3145573': PREFERENCE_LABELS.newsletter,
    '44212735': PREFERENCE_LABELS.health,
} as const;

export const pushNotificationPreferencesStaging = {
    '869272443': PREFERENCE_LABELS.marketing,
    '869272354': PREFERENCE_LABELS.surveys,
    '869272457': PREFERENCE_LABELS.product,
    '869272206': PREFERENCE_LABELS.health,
} as const;

export const pushNotificationPreferencesProduction = {
    '398821967': PREFERENCE_LABELS.marketing,
    '398824369': PREFERENCE_LABELS.surveys,
    '398824275': PREFERENCE_LABELS.product,
    '398824509': PREFERENCE_LABELS.health,
} as const;

export const smsPreferencesStaging = {
    '869271145': PREFERENCE_LABELS.marketing,
    '869271990': PREFERENCE_LABELS.surveys,
    '869271826': PREFERENCE_LABELS.product,
    '869272074': PREFERENCE_LABELS.health,
} as const;

export const smsPreferencesProduction = {
    '89767916': PREFERENCE_LABELS.marketing,
    '89767982': PREFERENCE_LABELS.surveys,
    '89767927': PREFERENCE_LABELS.product,
    '89767875': PREFERENCE_LABELS.health,
} as const;

type EmailPreferences =
    | Keys<typeof emailPreferencesProduction>
    | Keys<typeof emailPreferencesStaging>;

type PushNotificationPreferences =
    | Keys<typeof pushNotificationPreferencesStaging>
    | Keys<typeof pushNotificationPreferencesProduction>;

type SmsPreferences =
    | Keys<typeof smsPreferencesStaging>
    | Keys<typeof smsPreferencesProduction>;

export type ContactPreferences =
    | EmailPreferences
    | SmsPreferences
    | PushNotificationPreferences;

export type ContactPreferencesRequest = {
    quizToken: string;
    subscribe: ContactPreferences[];
    unsubscribe: ContactPreferences[];
};

export const smsPreferencesPayload =
    env.NEXT_PUBLIC_VARIANT === 'production'
        ? smsPreferencesProduction
        : smsPreferencesStaging;

export const smsPreferenceRequestPayload: SmsPreferences[] = Object.keys(
    smsPreferencesPayload,
) as SmsPreferences[];
